import React, { Component } from "react";
import styled from "styled-components";
import { CaseHistoryStore } from "Store";
import Header from "./HeaderWithStoreQuery";
import Filter from "module-case-management/list-panel/filter/FilterWithStore";
import List from "./ListWithStoreQuery";

export default class ListPanel extends Component {
  render() {
    const store = CaseHistoryStore;
    return (
      <Wrapper>
        <Header />
        <Filter store={store} />
        <List />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 350px;
  border-right: 1px solid ${props => props.theme.panelBorder};
`;



// WEBPACK FOOTER //
// ./src/module-case-history/list-panel/ListPanel.js